
<div class="text v-flex" :style="alignText">
    <a @click="onCopy">
        <div ref="text" class="mr-1 text" :class="color" >{{ text }}</div>
    </a>
</div>
